import { combineReducers } from "@reduxjs/toolkit";
import movementTypeSlice from "./slices/movementTypeSlice";
import inventoryProductSlice from "./slices/inventoryProductSlice";

export default combineReducers({
  movementType: movementTypeSlice,
  inventoryProduct: inventoryProductSlice,
});
